/*
 * Cabania — page « Compositions » (template page.compositions).
 * Dessin des plans, cotes, lien photo ↔ plan, quiz, hero, ajout au panier.
 *
 * Les données (plans, photos associées, modules) ne sont PAS dans ce fichier :
 * elles sont générées dans snippets/compositions-data.liquid par BUNDLES/generateur/build.mjs.
 * Ne pas modifier les plans à la main dans le thème : modifier compositions.json et relancer le générateur.
 *
 * Composants : <cab-composition>, <cab-quiz>, <cab-hero>, <cab-plan>.
 */
(function () {
  'use strict';
  if (window.CabaniaCompositions) return;

  /* ---------- Dimensions réelles des modules (cm) — fiches produit lit-cabane-cabania.com ---------- */
  var DIMS = { caseL: 42, caseH: 42, maisonL: 88.1, maisonH: 172, commodeL: 84, commodeH: 84, armoireL: 84.5, armoireH: 172 };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var HOUSE = '<svg viewBox="0 0 210 380" preserveAspectRatio="none" aria-hidden="true"><path d="M4 380 V100 L105 8 L206 100 V380" fill="none" stroke="#1D2142" stroke-width="BW" vector-effect="non-scaling-stroke"/><path d="M16 380 V106 L105 24 L194 106 V380" fill="none" stroke="#1D2142" stroke-width="1" vector-effect="non-scaling-stroke" opacity=".45"/><line x1="4" y1="226" x2="206" y2="226" stroke="#1D2142" stroke-width="1" vector-effect="non-scaling-stroke"/><line x1="4" y1="366" x2="206" y2="366" stroke="#1D2142" stroke-width="1" vector-effect="non-scaling-stroke"/></svg>';
  var WARD = '<svg viewBox="0 0 210 380" preserveAspectRatio="none" aria-hidden="true"><path d="M4 380 V100 L105 8 L206 100 V380 Z" fill="#F3E3C8" stroke="#1D2142" stroke-width="BW" vector-effect="non-scaling-stroke"/><rect x="72" y="104" width="128" height="272" fill="#FBF6EE" stroke="#1D2142" stroke-width="1" vector-effect="non-scaling-stroke"/><path d="M4 170 H72 M4 235 H72 M4 300 H72" stroke="#1D2142" stroke-width="1" vector-effect="non-scaling-stroke"/><polygon points="135,136 138.5,145.1 148.3,145.7 140.7,151.9 143.2,161.3 135,156 126.8,161.3 129.3,151.9 121.7,145.7 131.5,145.1" fill="#1D2142"/></svg>';

  /* Formes des 7 modules (légende « Les modules des compositions »). */
  var SHAPES = {
    maison: [['maison', 0]],
    commode: [['commode', 0, 0]],
    col2: [['cases', [[0, 0], [0, 1]]]],
    col3: [['cases', [[0, 0], [0, 1], [0, 2]]]],
    L: [['cases', [[0, 0], [1, 0], [1, 1]]]],
    esc6: [['cases', [[0, 0], [0, 1], [0, 2], [1, 0], [1, 1], [2, 0]]]],
    cube: [['cases', [[0, 0]]]],
    armoire: [['armoire', 0]]
  };

  /* ---------- Modèle : liste de modules lisible → formes positionnées ---------- */
  /* ["maison", x] · ["armoire", x] · ["commode", x, y] · ["cases", [[x, y], …]] (un module de cases) */
  function parse(list) {
    var p = [];
    (list || []).forEach(function (m, i) {
      if (m[0] === 'maison') p.push({ k: 'house', x: m[1], y: 0, w: 2.1, h: 3.8 });
      else if (m[0] === 'armoire') p.push({ k: 'wardrobe', x: m[1], y: 0, w: 2.1, h: 3.8 });
      else if (m[0] === 'commode') p.push({ k: 'commode', x: m[1], y: m[2] || 0, w: 2, h: 2 });
      else if (m[0] === 'cases') m[1].forEach(function (c) { p.push({ k: 'cube', x: c[0], y: c[1], w: 1, h: 1, g: i }); });
    });
    return p;
  }
  function bounds(p) { var w = 0, h = 0; p.forEach(function (m) { w = Math.max(w, m.x + m.w); h = Math.max(h, m.y + m.h); }); return { w: w, h: h }; }
  function unit(p, W, Hh, maxU) { var b = bounds(p); return Math.max(1, Math.min(maxU, W / b.w, Hh / b.h)); }

  /* Cotes en cm (arrondies, d'où le « ≈ » à l'affichage). */
  function cotesCm(p) {
    var b = bounds(p), d = DIMS;
    var houses = p.filter(function (m) { return m.k === 'house'; }).length, wards = p.filter(function (m) { return m.k === 'wardrobe'; }).length;
    var stackTop = 0, hasCom = false;
    p.forEach(function (m) { if (m.k === 'cube') stackTop = Math.max(stackTop, m.y + 1); if (m.k === 'commode') hasCom = true; });
    var L = Math.round(b.w * d.caseL + houses * (d.maisonL - 2.1 * d.caseL) + wards * (d.armoireL - 2.1 * d.caseL));
    var hs = [stackTop * d.caseH];
    if (houses) hs.push(d.maisonH);
    if (wards) hs.push(d.armoireH);
    if (hasCom) hs.push(d.commodeH + (p.some(function (m) { return m.k === 'cube' && m.y >= 2; }) ? d.caseH : 0));
    return { L: L, H: Math.round(Math.max.apply(null, hs)) };
  }
  function cotesTxt(p) { var c = cotesCm(p); return { l: 'L ≈ ' + c.L + ' cm', h: 'H ≈ ' + c.H + ' cm' }; }

  /* Trait des cases : contour du module épais (à cheval sur le bord, jamais doublé quand deux modules se touchent),
     séparation interne fine, tracée une seule fois (par la case de gauche / du bas). */
  function mate(m, p, dx, dy) {
    return p.some(function (n) { return n !== m && n.k === 'cube' && n.g === m.g && n.y === m.y + dy && Math.abs(n.x - (m.x + dx)) < 0.15; });
  }
  function edges(el, m, p) {
    var t = mate(m, p, 0, 1), r = mate(m, p, 1, 0), b = mate(m, p, 0, -1), l = mate(m, p, -1, 0);
    var half = 'calc(var(--bw) / -2)';
    el.dataset.e = (t ? 'i' : 'o') + (r ? 'i' : 'o') + (b ? 'i' : 'o') + (l ? 'i' : 'o');
    el.style.cssText = '--wt:' + (t ? 'var(--thin)' : 'var(--bw)') + ';--ot:' + (t ? '0px' : half) +
      ';--wr:' + (r ? 'var(--thin)' : 'var(--bw)') + ';--or:' + (r ? '0px' : half) +
      ';--wb:' + (b ? '0px' : 'var(--bw)') + ';--ob:' + (b ? '0px' : half) +
      ';--wl:' + (l ? '0px' : 'var(--bw)') + ';--ol:' + (l ? '0px' : half);
  }
  function inner(m, bw) {
    if (m.k === 'cube') return '<div class="cab-m-cube"></div>';
    if (m.k === 'commode') return '<div class="cab-m-com"><i></i><i></i><i></i></div>';
    return (m.k === 'house' ? HOUSE : WARD).replace('BW', bw);
  }

  /* Construit (ou met à jour en place, pour animer) un plan dans `host`. */
  function draw(host, p, W, Hh, maxU, withCotes) {
    if (!host || !p.length) return null;
    var U = unit(p, W, Hh, maxU), b = bounds(p);
    var thin = U > 30 ? 1.5 : 1, bw = 2 * thin, ins = U > 30 ? 4 : (U > 16 ? 2 : 0);
    var sil = host.querySelector('.cab-sil');
    if (!sil) { sil = document.createElement('div'); sil.className = 'cab-sil'; sil.innerHTML = '<div class="cab-mods"></div>'; host.appendChild(sil); }
    sil.style.width = (b.w * U).toFixed(1) + 'px'; sil.style.height = (b.h * U).toFixed(1) + 'px';
    sil.style.setProperty('--bw', bw + 'px'); sil.style.setProperty('--thin', thin + 'px'); sil.style.setProperty('--in', ins + 'px');
    var mods = sil.querySelector('.cab-mods'), kids = mods.children;
    p.forEach(function (m, i) {
      var el = kids[i];
      if (!el || el.dataset.k !== m.k) {
        var n = document.createElement('div'); n.dataset.k = m.k; n.innerHTML = inner(m, bw);
        if (el) mods.replaceChild(n, el); else mods.appendChild(n); el = n;
      }
      el.style.left = (m.x * U).toFixed(1) + 'px'; el.style.bottom = (m.y * U).toFixed(1) + 'px';
      el.style.width = (m.w * U).toFixed(1) + 'px'; el.style.height = (m.h * U).toFixed(1) + 'px';
      if (m.k === 'cube') edges(el.firstChild, m, p);
    });
    while (mods.children.length > p.length) mods.removeChild(mods.lastChild);
    if (withCotes) {
      var c = cotesTxt(p), ch = sil.querySelector('.cab-cote-h'), cv = sil.querySelector('.cab-cote-v');
      if (!ch) { ch = document.createElement('div'); ch.className = 'cab-cote cab-cote-h'; ch.innerHTML = '<span></span>'; sil.appendChild(ch); }
      if (!cv) { cv = document.createElement('div'); cv.className = 'cab-cote cab-cote-v'; cv.innerHTML = '<span></span>'; sil.appendChild(cv); }
      ch.firstChild.textContent = c.l; cv.firstChild.textContent = c.h;
      host.setAttribute('role', 'img');
      host.setAttribute('aria-label', 'Plan : ' + c.l.replace('L', 'largeur') + ', ' + c.h.replace('H', 'hauteur'));
    }
    return sil;
  }
  function stageFor(el, p, W, Hh, maxU, withCotes) { el.innerHTML = ''; return draw(el, p, W, Hh, maxU, withCotes); }
  /* Photo responsive : srcset généré (600 / 1000 / 1600 px). */
  function setPhoto(img, src, srcset, sizes) {
    if (img.getAttribute('src') === src) return;
    if (srcset) { img.srcset = srcset; img.sizes = sizes; } else img.removeAttribute('srcset');
    img.src = src;
  }
  function fileKey(u) { var m = /\/([^\/?]+?)(?:_\d*x\d*)?\.(?:jpe?g|png|webp)/i.exec(u || ''); return m ? m[1].toLowerCase() : ''; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

  /* ---------- Données ---------- */
  function readJSON(root, sel) {
    var s = root && root.querySelector(sel);
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { console.warn('[Cabania] données illisibles', e); return null; }
  }
  /* Données d'une composition, lisibles même avant la mise à niveau du custom element. */
  function compoData(el) {
    if (el._cab) return el._cab;
    var d = readJSON(el, 'script[data-cab-plans]');
    if (!d) return null;
    d.plans.forEach(function (pl) { pl.p = parse(pl.modules); });
    d.name = el.dataset.title || d.nom;
    d.besoin = el.dataset.besoin || d.besoin;
    d.place = el.dataset.place || d.place;
    d.total = d.plans.length;
    d.start = Math.min(d.plan_initial || 0, d.total - 1);
    d.el = el;
    el._cab = d;
    return d;
  }
  function compositions() {
    return Array.prototype.map.call(document.querySelectorAll('cab-composition'), compoData).filter(Boolean);
  }
  var idees = null;
  function ideeData(id) {
    if (!idees) { idees = {}; var d = readJSON(document, 'script[data-cab-idees]'); (d ? d.idees : []).forEach(function (i) { i.p = parse(i.modules); idees[i.id] = i; }); }
    return idees[id];
  }

  /* Recommandation partagée entre quiz, hero et compositions. */
  var state = { besoin: null, place: null, current: null };
  function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail })); }

  /* ---------- Panier : API AJAX Shopify, puis événement du thème Expanse (ouvre le tiroir panier) ---------- */
  function cartAdd(btn, variant, properties, err, detail) {
    if (!variant || btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true; btn.classList.add('btn--loading'); if (err) err.hidden = true;
    var routes = (window.theme && window.theme.routes) || {};
    var item = { id: +variant, quantity: 1 };
    if (properties) item.properties = properties;
    fetch(routes.cartAdd || '/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
      btn.disabled = false; btn.classList.remove('btn--loading');
      if (!res.ok) { if (err) { err.textContent = res.j.description || res.j.message || 'Ajout impossible.'; err.hidden = false; } return; }
      var settings = (window.theme && window.theme.settings) || {};
      emit('cabania:add', Object.assign({ variant: +variant }, detail || {}));
      if (settings.cartType === 'page') { window.location = routes.cartPage || '/cart'; return; }
      btn.classList.add('cab-btn--done'); btn.textContent = 'Ajouté au panier';
      setTimeout(function () { btn.classList.remove('cab-btn--done'); btn.textContent = label; }, 2500);
      var product = res.j.items ? res.j.items[0] : res.j;
      btn.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: product, addToCartBtn: btn }, bubbles: true }));
    }).catch(function () {
      btn.disabled = false; btn.classList.remove('btn--loading');
      if (err) { err.textContent = 'Ajout impossible. Vérifiez votre connexion et réessayez.'; err.hidden = false; }
    });
  }
  /* Modules à l'unité : <button data-cab-add-variant="id"> */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cab-add-variant]');
    if (!b) return;
    var card = b.closest('.cab-unit');
    cartAdd(b, b.dataset.cabAddVariant, null, card && card.querySelector('[data-cab-error]'), { type: 'module' });
  });

  /* Vue à afficher. demandée : null (plan choisi) | 'amb' (photo d'ambiance) | 'pack' (image du produit).
     Le plan choisi s'affiche par son packshot (photo exacte du plan), sinon dessiné.
     Les photos d'ambiance (« photo » dans compositions.json) ne sont pas des photos exactes du plan : jamais affichées comme telles.
     Renvoie 'ps' | 'plan' | 'amb' | 'pack'. */
  function viewFor(asked, pl, hasPack, amb) {
    if (asked === 'pack' && hasPack) return 'pack';
    if (asked === 'amb' && amb && amb.photo) return 'amb';
    return pl.packshot ? 'ps' : 'plan';
  }
  /* Phrase sous la galerie. */
  function photosText(total, nPs, nAmb) {
    var t = nPs === total ? 'Chaque plan en photo' : nPs ? nPs + ' plans sur ' + total + ' en photo' : 'Plans dessinés, photos à venir';
    if (nPs) t += ' : cliquez une photo ou un plan, l\'autre suit';
    if (nAmb) t += '. ' + (nAmb > 1 ? nAmb + ' photos d\'ambiance' : '1 photo d\'ambiance') + ' en fin de galerie';
    return t + '.';
  }

  /* ---------- <cab-composition> : galerie ↔ plan, navigation, panier ---------- */
  class CabComposition extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      var c = compoData(this);
      if (!c) return;
      this._ready = true;
      this.st = { cfg: c.start, view: null, amb: null };
      var pack = { src: this.dataset.packSrc, srcset: this.dataset.packSrcset, thumb: this.dataset.packThumb, alt: this.dataset.packAlt || '' };
      this.pack = pack;
      var thumbs = this.querySelector('.cab-thumbs'), cfg = this.querySelector('.cab-plan__cfg');
      /* Galerie : un packshot par plan, dans l'ordre des plans. */
      var strip = thumbs.querySelector('.cab-thumbs__strip');
      strip.innerHTML = c.plans.map(function (pl, j) {
        return pl.packshot ? '<button type="button" class="cab-thumb cab-thumb--ps" data-cfg="' + j + '" aria-label="Plan ' + (j + 1) + ' : ' + esc(pl.nom) + '"><img src="' + esc(pl.pack_vignette) + '" alt="" loading="lazy" width="108" height="144"></button>' : '';
      }).join('');
      /* Galerie = packshots des plans uniquement (choix éditorial 15/10) : les photos d'ambiance servent au hero, l'image du produit à la fiche produit. */
      cfg.innerHTML = c.plans.map(function (pl, j) {
        return '<button type="button" data-cfg="' + j + '" aria-label="Plan ' + (j + 1) + ' : ' + esc(pl.nom) + '"><div class="cab-stage"></div></button>';
      }).join('');
      var nPs = c.plans.filter(function (pl) { return pl.packshot; }).length;
      var ml = this.querySelector('[data-cab-modules]');
      if (ml && c.modules) ml.textContent = c.modules.join(' · ');
      this.querySelector('[data-cab-count]').textContent = 'Les ' + c.total + ' plans';
      this.querySelector('[data-cab-photos]').textContent = photosText(c.total, nPs, 0);
      cfg.querySelectorAll('button').forEach(function (b, j) { stageFor(b.querySelector('.cab-stage'), c.plans[j].p, 76, 46, 13); });
      this.addEventListener('click', this.onClick.bind(this));
      this._onResize = debounce(this.sync.bind(this), 150);
      window.addEventListener('resize', this._onResize);
      this.sync();
      this.mark();
    }
    disconnectedCallback() { window.removeEventListener('resize', this._onResize); }
    mark() { var tag = this.querySelector('[data-cab-rec]'); if (tag) tag.hidden = !(state.current && state.current === this._cab.id); }
    onClick(e) {
      var b = e.target.closest('button'), c = this._cab;
      if (!b || !this.contains(b)) return;
      if (b.dataset.cfg != null) { this.st.cfg = +b.dataset.cfg; this.st.view = null; this.sync(); }
      else if (b.dataset.step) { this.st.cfg = (this.st.cfg + (+b.dataset.step) + c.total) % c.total; this.st.view = null; this.sync(); }
      else if (b.dataset.amb != null) { this.st.view = 'amb'; this.st.amb = +b.dataset.amb; this.sync(); }
      else if (b.dataset.pack) { this.st.view = 'pack'; this.sync(); }
      else if (b.matches('[data-cab-add]')) this.add(b);
    }
    sync() {
      var c = this._cab, st = this.st, pl = c.plans[st.cfg], amb = st.amb != null ? c.plans[st.amb] : null;
      var view = viewFor(st.view, pl, !!this.pack.src, amb);
      var showImg = view !== 'plan';
      var media = this.querySelector('.cab-media'), img = media.querySelector(':scope > img'), noimg = this.querySelector('.cab-noimg'), big = this.querySelector('.cab-stage--big');
      img.hidden = !showImg; noimg.hidden = showImg;
      media.classList.toggle('cab-media--ps', view === 'ps');
      /* URL absolue : une url() dans une variable CSS se résout depuis la feuille de style, pas depuis la page. */
      media.style.setProperty('--cab-bg', view === 'ps' ? 'url("' + new URL(pl.pack_vignette, document.baseURI).href + '")' : 'none');
      if (showImg) {
        if (view === 'pack') setPhoto(img, this.pack.src, this.pack.srcset, '(min-width: 1100px) 50vw, 100vw');
        else if (view === 'ps') setPhoto(img, pl.packshot, pl.pack_srcset, '(min-width: 1100px) 38vw, 75vw');
        else setPhoto(img, amb.photo, amb.srcset, '(min-width: 1100px) 50vw, 100vw');
        img.alt = view === 'pack' ? this.pack.alt : view === 'ps' ? (pl.pack_alt || pl.nom) : (amb.alt || c.nom || '');
      } else {
        var ns = noimg.querySelector('.cab-stage');
        stageFor(ns, pl.p, Math.min(460, (noimg.clientWidth || 520) - 110), Math.max(150, (noimg.clientHeight || 390) - 170), 60, true);
      }
      this.querySelector('[data-cab-lbl]').textContent = view === 'pack' ? 'Les modules livrés' : view === 'amb' ? 'Ambiance · un exemple de chambre' : 'Plan ' + (st.cfg + 1) + ' · ' + pl.nom;
      this.querySelector('[data-cab-cfg-l]').textContent = pl.nom;
      this.querySelector('[data-cab-cfg-n]').textContent = 'Plan ' + (st.cfg + 1) + ' sur ' + c.total;
      draw(big, pl.p, Math.min(380, (big.clientWidth || 440) - 90), 180, 46, true);
      var on = null;
      this.querySelectorAll('.cab-thumb').forEach(function (t) {
        var p = t.dataset.pack ? view === 'pack' : t.dataset.amb != null ? (view === 'amb' && +t.dataset.amb === st.amb) : ((view === 'ps' || view === 'plan') && +t.dataset.cfg === st.cfg);
        t.setAttribute('aria-pressed', String(p)); if (p) on = t;
      });
      /* Vignette active visible dans la bande (défilement horizontal seulement, la page ne bouge pas). */
      var strip = this.querySelector('.cab-thumbs__strip');
      if (on && strip && strip.scrollWidth > strip.clientWidth) {
        var l = on.offsetLeft - strip.offsetLeft, r = l + on.offsetWidth;
        if (l < strip.scrollLeft) strip.scrollLeft = l - 8; else if (r > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = r - strip.clientWidth + 8;
      }
      this.querySelectorAll('.cab-plan__cfg button').forEach(function (t) { t.setAttribute('aria-pressed', String(+t.dataset.cfg === st.cfg)); });
      var input = this.querySelector('[data-cab-plan-input]');
      if (input) input.value = pl.nom;
    }
    /* Ajout au panier : API AJAX Shopify, puis événement du thème (ouvre le tiroir panier d'Expanse). */
    add(btn) {
      var c = this._cab, nom = c.plans[this.st.cfg].nom;
      cartAdd(btn, this.dataset.variant, { 'Plan choisi': nom }, this.querySelector('[data-cab-error]'), { id: c.id, plan: nom });
    }
  }

  /* ---------- <cab-plan> : un plan seul (principe, légende des modules, idées) ---------- */
  class CabPlan extends HTMLElement {
    connectedCallback() {
      var d = this.dataset, p = null;
      if (d.shape) p = parse(SHAPES[d.shape]);
      else if (d.idee) { var i = ideeData(d.idee); p = i && i.p; }
      else if (d.jeu) {
        var c = compositions().filter(function (x) { return x.id === d.jeu; })[0];
        if (!c) { var src = readJSON(document, 'script[data-cab-plans="' + d.jeu + '"]'); if (src) c = { plans: src.plans.map(function (pl) { return { p: parse(pl.modules) }; }) }; }
        p = c && c.plans[+(d.plan || 0)] && c.plans[+(d.plan || 0)].p;
      }
      if (!p) return;
      this.p = p;
      var self = this;
      var render = function () { stageFor(self, p, +(d.w || 300), +(d.h || 100), +(d.u || 26), d.cotes != null); };
      render();
      if (d.cotes != null) { this._onResize = debounce(render, 150); window.addEventListener('resize', this._onResize); }
      var out = d.dims ? document.getElementById(d.dims) : null;
      if (out) { var t = cotesTxt(p); out.textContent = t.l + ' × ' + t.h.replace('H ', ''); }
    }
    disconnectedCallback() { if (this._onResize) window.removeEventListener('resize', this._onResize); }
  }

  /* ---------- <cab-quiz> : 2 questions → tableau besoin × place ---------- */
  var ROWS = [['jeu', 'Jouets et livres'], ['vet', 'Vêtements et linge']], COLS = [['coin', 'Un coin de la chambre'], ['mur', 'Tout un pan de mur']];
  class CabQuiz extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.querySelectorAll('.cab-seg').forEach(function (seg) {
        seg.addEventListener('click', function (e) {
          var b = e.target.closest('button'); if (!b) return;
          state[seg.dataset.q] = state[seg.dataset.q] === b.dataset.v ? null : b.dataset.v;
          self.update();
        });
      });
      this.build();
      this._onReload = function () { self.build(); };
      document.addEventListener('shopify:section:load', this._onReload);
      document.addEventListener('shopify:section:unload', this._onReload);
    }
    disconnectedCallback() { document.removeEventListener('shopify:section:load', this._onReload); document.removeEventListener('shopify:section:unload', this._onReload); }
    build() {
      var mx = this.querySelector('[data-cab-matrix]'), all = compositions(), self = this;
      mx.innerHTML = '';
      ROWS.forEach(function (r) {
        var row = document.createElement('div'); row.className = 'cab-mx-row';
        row.innerHTML = '<span class="cab-mx-label">' + r[1] + '</span>';
        mx.appendChild(row);
        COLS.forEach(function (col) {
          var list = all.filter(function (x) { return x.besoin === r[0] && x.place === col[0]; });
          var b = document.createElement('button'); b.type = 'button'; b.className = 'cab-cell';
          b.setAttribute('aria-pressed', 'false');
          b.dataset.besoin = r[0]; b.dataset.place = col[0];
          if (!list.length) { b.disabled = true; b.innerHTML = '<div class="cab-stage"></div><span class="cab-cell__sub">Aucune composition</span>'; row.appendChild(b); return; }
          var c = list[0];
          b.dataset.id = c.id;
          b.setAttribute('aria-label', list.map(function (x) { return x.name; }).join(' ou ') + ' : ' + r[1].toLowerCase() + ', ' + col[1].toLowerCase());
          b.innerHTML = '<div class="cab-stage"></div><b>' + esc(list.map(function (x) { return x.name; }).join(' · ')) + '</b><span class="cab-cell__sub">' + c.plans.length + ' plans</span>';
          row.appendChild(b);
          stageFor(b.querySelector('.cab-stage'), c.plans[c.start].p, Math.min(160, (b.clientWidth || 180) - 24), 80, 22);
          b.addEventListener('click', function () { state.besoin = r[0]; state.place = col[0]; self.update(); });
        });
      });
      this.update();
    }
    update() {
      this.querySelectorAll('.cab-seg').forEach(function (seg) {
        seg.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(state[seg.dataset.q] === b.dataset.v)); });
      });
      var cur = (state.besoin && state.place) ? compositions().filter(function (c) { return c.besoin === state.besoin && c.place === state.place; })[0] : null;
      state.current = cur ? cur.id : null;
      this.querySelectorAll('.cab-cell').forEach(function (cell) {
        cell.setAttribute('aria-pressed', String(!!cur && cell.dataset.id === cur.id));
        cell.classList.toggle('cab-is-dim', !!((state.besoin && cell.dataset.besoin !== state.besoin) || (state.place && cell.dataset.place !== state.place)));
      });
      var txt = this.querySelector('[data-cab-reco-txt]'), cta = this.querySelector('[data-cab-reco-cta]');
      if (cur) {
        txt.textContent = cur.name + ' : ' + cur.plans.length + ' plans possibles.';
        cta.hidden = false; cta.textContent = 'Voir ' + cur.name; cta.href = '#' + cur.el.id;
      } else {
        txt.textContent = txt.dataset.default || '';
        cta.hidden = true;
      }
      compositions().forEach(function (c) { if (c.el.mark) c.el.mark(); });
      emit('cabania:reco', { id: state.current });
    }
  }

  /* ---------- <cab-hero> : photos en situation qui défilent avec leur plan coté ---------- */
  class CabHero extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.photo = this.querySelector('.cab-hero__img > img');
      this.stage = this.querySelector('[data-cab-hero-stage]');
      this.step = 0;
      var self = this;
      this._onReco = function (e) { self.reco(e.detail.id); };
      document.addEventListener('cabania:reco', this._onReco);
      this._onResize = debounce(function () { self.show(self.last); }, 150);
      window.addEventListener('resize', this._onResize);
      /* Démarre sur le plan qui correspond à la photo d'ouverture (si elle en fait partie) : pas de changement d'image au chargement. */
      var key = fileKey(this.photo && this.photo.currentSrc || this.photo && this.photo.getAttribute('src')), seq = this.seq();
      var at = seq.findIndex(function (it) { return fileKey(it[0].plans[it[1]].photo) === key; });
      this.step = Math.max(0, at);
      this.paused = reduced;
      /* Pause : bouton, survol, focus, onglet masqué (WCAG 2.2.2). */
      this.pauseBtn = this.querySelector('[data-cab-hero-pause]');
      /* Flèches : navigation manuelle, met le défilement en pause (l'utilisateur garde la main). */
      this.querySelectorAll('[data-cab-hero-step]').forEach(function (b) { b.addEventListener('click', function () { self.go(+b.dataset.cabHeroStep); }); });
      if (this.pauseBtn) {
        if (reduced) this.pauseBtn.hidden = true;
        this.pauseBtn.addEventListener('click', function () { self.paused = !self.paused; self.syncPause(); });
      }
      var hold = function (on) { return function () { self.hold = on; self.syncPause(); }; };
      this.addEventListener('mouseenter', hold(true)); this.addEventListener('mouseleave', hold(false));
      this.addEventListener('focusin', hold(true)); this.addEventListener('focusout', hold(false));
      this._onVis = function () { self.syncPause(); };
      document.addEventListener('visibilitychange', this._onVis);
      if (at >= 0) this.show(seq[at], (at + 1) + ' / ' + seq.length, true); else this.cycle();
      this.syncPause();
    }
    syncPause() {
      if (this.pauseBtn && this._icon !== !!this.paused) {
        this._icon = !!this.paused;
        this.pauseBtn.setAttribute('aria-pressed', String(!!this.paused));
        this.pauseBtn.setAttribute('aria-label', this.paused ? 'Reprendre le défilement des photos' : 'Mettre en pause le défilement des photos');
        this.pauseBtn.innerHTML = this.paused
          ? '<svg width="10" height="12" viewBox="0 0 10 12" aria-hidden="true"><path d="M0 0l10 6-10 6z" fill="#1D2142"/></svg>'
          : '<svg width="10" height="12" viewBox="0 0 10 12" aria-hidden="true"><path d="M0 0h3v12H0zM7 0h3v12H7z" fill="#1D2142"/></svg>';
      }
      if (this.reco_ || this.paused || this.hold || document.hidden) this.stop(); else this.start();
    }
    disconnectedCallback() { this.stop(); document.removeEventListener('cabania:reco', this._onReco); window.removeEventListener('resize', this._onResize); document.removeEventListener('visibilitychange', this._onVis); }
    seq() { var s = []; compositions().forEach(function (c) { c.plans.forEach(function (pl, j) { if (pl.photo) s.push([c, j]); }); }); return s; }
    show(item, counter, keepPhoto) {
      if (!item || !this.stage) return;
      this.last = item;
      var c = item[0], pl = c.plans[item[1]], ph = this.photo;
      if (!keepPhoto && ph && pl.photo && fileKey(ph.currentSrc || ph.getAttribute('src')) !== fileKey(pl.photo)) {
        ph.classList.add('cab-is-fading');
        setTimeout(function () { setPhoto(ph, pl.photo, pl.srcset, '(min-width: 1024px) 55vw, 100vw'); ph.alt = pl.alt || pl.nom; ph.classList.remove('cab-is-fading'); }, reduced ? 0 : 250);
      }
      draw(this.stage, pl.p, Math.min(320, (this.stage.clientWidth || 360) - 90), 120, 30, true);
      this.querySelector('[data-cab-hero-cap]').innerHTML = '<strong>' + esc(c.name) + '</strong> · ' + esc(pl.nom);
      this.querySelector('[data-cab-hero-count]').textContent = counter || '';
    }
    go(d) {
      var s = this.seq(); if (!s.length) return;
      this.reco_ = false;
      this.step = ((this.step + d) % s.length + s.length) % s.length;
      this.paused = true; this.syncPause();
      this.cycle();
    }
    cycle() { var s = this.seq(); if (!s.length) return; var i = this.step % s.length; this.show(s[i], (i + 1) + ' / ' + s.length); }
    start() { if (this.timer || reduced) return; var self = this; this.timer = setInterval(function () { self.step++; self.cycle(); }, 3200); }
    stop() { if (this.timer) clearInterval(this.timer); this.timer = null; }
    reco(id) {
      var c = compositions().filter(function (x) { return x.id === id; })[0];
      this.reco_ = !!c;
      if (!c) { this.syncPause(); return; }
      this.stop();
      var j = c.plans[c.start].photo ? c.start : Math.max(0, c.plans.findIndex(function (pl) { return pl.photo; }));
      var k = this.seq().findIndex(function (it) { return it[0] === c && it[1] === j; });
      if (k >= 0) this.step = k;
      this.show([c, j]);
    }
  }

  document.addEventListener('shopify:section:load', function () { idees = null; });

  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }

  /* Point d'accès pour les tests et le débogage. */
  window.CabaniaCompositions = { parse: parse, cotesCm: cotesCm, cotesTxt: cotesTxt, bounds: bounds, SHAPES: SHAPES, DIMS: DIMS, state: state, viewFor: viewFor, photosText: photosText };

  if (!customElements.get('cab-composition')) customElements.define('cab-composition', CabComposition);
  if (!customElements.get('cab-plan')) customElements.define('cab-plan', CabPlan);
  if (!customElements.get('cab-quiz')) customElements.define('cab-quiz', CabQuiz);
  if (!customElements.get('cab-hero')) customElements.define('cab-hero', CabHero);
})();
